import React from "react";
import cx from "classnames";
import noop from "lodash/noop";

function Modal({
  children,
  width,
  className,
  toClear,
  onClose = noop(),
  canClose = true,
  narrow = false,
  backButton = false,
  forwardButton = false,
  changeCloseIcon = false,
  overflowModal = false,
  goBack = () => {},
  goForward = () => {},
  dontRefreshOnClose,
  allowInsideModal = false,
  chatGroupEdit = false,
}) {
  if (toClear) {
    if (!Array.isArray(toClear)) toClear = [toClear];
    toClear = toClear.join("=&");
  }

  const refreshUrl = chatGroupEdit
    ? `/actions/refresh?groupParticipants=&groupSubject=&allGroupChats=&groupChatId=&groupImage=&groupEdited=&modal=`
    : `/actions/refresh?modal=`;

  if (typeof onClose !== "function") onClose = (e) => undefined;
  return (
    <div className={cx("Modal-Box", className)}>
      {toClear &&
        (dontRefreshOnClose ? (
          <div className="overlay" onClick={(e) => onClose(e)}></div>
        ) : (
          <a
            href={`/actions/refresh?modal=&${toClear}=`}
            onClick={(e) => onClose(e)}
            className="overlay"
          />
        ))}
      {!toClear &&
        (dontRefreshOnClose ? (
          <div className="overlay" onClick={(e) => onClose(e)}></div>
        ) : (
          <a
            href={refreshUrl}
            onClick={(e) => onClose(e)}
            className="overlay"
          />
        ))}
      {backButton && (
        <div className="modal-nav-btn modal-back" onClick={goBack}>
          <img
            className="modal-nav-icon"
            src="/img/svg/angle-left.svg"
            alt="next"
          />
        </div>
      )}
      <div
        className={`box ${narrow ? "narrow-box" : ""} ${
          overflowModal ? "responsive-modal-vertical" : ""
        }`}
        style={
          allowInsideModal
            ? { overflow: "initial" }
            : { maxWidth: width, width }
        }
      >
        {canClose && dontRefreshOnClose ? (
          <div className="close">
            <img
              className="icon-red"
              src="/img/new-icons/close-modal.svg"
              alt="dismiss"
              onClick={(e) => onClose(e)}
            />
          </div>
        ) : (
          <a
            href={`/actions/refresh?modal=&${toClear}=`}
            onClick={(e) => onClose(e)}
          />
        )}
        {canClose &&
          !changeCloseIcon &&
          !dontRefreshOnClose &&
          !chatGroupEdit && (
            <a
              href={`/actions/refresh?modal=&${toClear}=`}
              onClick={(e) => onClose(e)}
              className="close"
            >
              <img
                className="icon-red"
                src="/img/new-icons/close-modal.svg"
                alt="dismiss"
              />
            </a>
          )}
        {canClose && changeCloseIcon && (
          <a
            href={`/actions/refresh?modal=&${toClear}=`}
            onClick={(e) => onClose(e)}
            className="close body-gym-modal-close"
          >
            <img
              height={15}
              width={15}
              className="icon-white"
              src="/img/new-icons/close-modal.svg"
              alt="dismiss"
            />
          </a>
        )}
        {children}
      </div>
      {forwardButton && (
        <div className="modal-nav-btn modal-forward" onClick={goForward}>
          <img
            className="modal-nav-icon"
            src="/img/svg/angle-right.svg"
            alt="next"
          />
        </div>
      )}
    </div>
  );
}

export default Modal;
